import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class EmailSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Flattened account fields
      username: "",
      password: "",
      host: "",
      port: 587,
      emailEncryption: "",
      // List of accounts
      accounts: [],
      // Pagination
      page: 0,
      size: 10,
      totalPages: 1,
      // UI state
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      editing: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchAccounts = this.fetchAccounts.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchAccounts(0, 10, token);
  }

  fetchAccounts(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getemailaccount", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let accounts = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          accounts = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          accounts = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          accounts = [response.data];
        }
        this.setState({
          accounts: accounts,
          page: page,
          totalPages: totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          accounts: [],
          totalPages: 1,
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load email accounts.",
          msg:
            error?.response?.data?.message || "Failed to load email accounts.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "port") {
      newValue = parseInt(value) || 587;
    }
    this.setState({ [name]: newValue }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Explicit validation for each field
      if (!s.username || !s.username.trim()) {
        errors.username = "Username is required";
        valid = false;
      }
      if (!s.password || !s.password.trim()) {
        errors.password = "Password is required";
        valid = false;
      }
      if (!s.host || !s.host.trim()) {
        errors.host = "Host is required";
        valid = false;
      }
      if (!s.port || isNaN(s.port) || s.port <= 0) {
        errors.port = "Port is required and must be a positive number";
        valid = false;
      }
      if (!s.emailEncryption || !s.emailEncryption.trim()) {
        errors.emailEncryption = "Encryption type is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      username: this.state.username,
      password: this.state.password,
      host: this.state.host,
      port: this.state.port,
      emailEncryption: this.state.emailEncryption,
    };

    const self = this;
    axios
      .post(API + "/settings/emailaccountsave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Email account saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            username: "",
            password: "",
            host: "",
            port: 587,
            emailEncryption: "",
            editing: false,
            errors: {},
          });
          // Refetch data
          self.fetchAccounts(self.state.page, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save email account.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save email account. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(account) {
    this.setState(
      {
        username: account.username || "",
        password: account.password || "",
        host: account.host || "",
        port: account.port || 587,
        emailEncryption: account.emailEncryption || "",
        editing: true,
      },
      this.validate
    );
  }

  handleAdd() {
    this.setState(
      {
        username: "",
        password: "",
        host: "",
        port: 587,
        emailEncryption: "",
        editing: true,
      },
      this.validate
    );
  }

  handleCancelEdit() {
    this.setState({
      username: "",
      password: "",
      host: "",
      port: 587,
      emailEncryption: "",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchAccounts(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchAccounts(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Email Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 w-100" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Username</label>
                    <input
                      name="username"
                      className={`form-control ${
                        s.errors.username ? " !border-red-500" : ""
                      }`}
                      value={s.username}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.username && (
                      <span className="input-group-error">
                        {s.errors.username}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Password</label>
                    <input
                      name="password"
                      type="password"
                      className={`form-control ${
                        s.errors.password ? " !border-red-500" : ""
                      }`}
                      value={s.password}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.password && (
                      <span className="input-group-error">
                        {s.errors.password}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Host</label>
                    <input
                      name="host"
                      className={`form-control ${
                        s.errors.host ? " !border-red-500" : ""
                      }`}
                      value={s.host}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.host && (
                      <span className="input-group-error">{s.errors.host}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Port</label>
                    <input
                      name="port"
                      type="number"
                      className={`form-control ${
                        s.errors.port ? " !border-red-500" : ""
                      }`}
                      value={s.port}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.port && (
                      <span className="input-group-error">{s.errors.port}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Encryption</label>
                    <input
                      name="emailEncryption"
                      className={`form-control ${
                        s.errors.emailEncryption ? " !border-red-500" : ""
                      }`}
                      value={s.emailEncryption}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.emailEncryption && (
                      <span className="input-group-error">
                        {s.errors.emailEncryption}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="d-flex gap-2 mb-2 align-items-baseline justify-content-between">
                  <h3 className="fw-bold">Configured Email Accounts</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={this.handleAdd}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.accounts.length === 0 ? (
                  <div className="text-muted">No email accounts found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="table table-striped table-hover rounded">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Username
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Host
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Port
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Encryption
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {s.accounts.map((account, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.username}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.host}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.port}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.emailEncryption}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-primary"
                                onClick={() => this.handleEdit(account)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
